import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import RBButton from '../controls/RBButton'
import { computer } from '../assets/images'
import Footer from '../widgets/common/Footer'
import Isvg from 'react-inlinesvg'
import { goBack } from 'connected-react-router'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'

class NotFound extends Component {
  constructor () {
    super()
    this.animate = this.animate.bind(this)
    this.state = {}
  }

  animate () {
    this.setState({
      animateClass: 'moveUp'
    })
  }

  componentDidMount () {
    setTimeout(this.animate, 200)
  }

  render () {
    // const logo = localizeImg('/img/404_computer.svg')
    return (
      <div>
        <section className={'notFound ' + this.state.animateClass}>
          <Grid fluid>
            <Row middle='xs' >
              <Col xs={12} md={8} mdOffset={2} >
                <Isvg className='computer' src={computer} />
                <h1>404</h1>
                <h2>{localize('pages.404.lost')}</h2>
                <h3>{localize('pages.404.doesNotExist')}</h3>
                <RBButton variant='contained' primary label={localize('pages.404.goBack')} className='goBack' onClick={this.props.goBack} />

              </Col>
            </Row>
          </Grid>

        </section>

        <Footer />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators({ goBack }, dispatch)
}
const ConnectedNotFound = connect(mapStateToProps, mapDispatchToProps)(injectIntl(NotFound))

export default ConnectedNotFound



// WEBPACK FOOTER //
// ./src/components/NotFound.js